import { useCallback } from 'react';
import { useLocation, useNavigation, useSearchParams } from 'react-router';

export default function useSelectedSize(): [
  string | undefined,
  (size?: string) => void
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const setSelectedSize = useCallback(
    (size?: string) =>
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);

          if (size) next.set('size', size);
          else next.delete('size');

          return next;
        },
        { preventScrollReset: true, replace: true }
      ),
    [setSearchParams]
  );

  const location = useLocation();
  const navigation = useNavigation();
  const pendingLocation =
    navigation.location?.pathname === location.pathname
      ? navigation.location
      : undefined;
  const params = pendingLocation
    ? new URLSearchParams(pendingLocation.search)
    : searchParams;

  return [params.get('size') ?? undefined, setSelectedSize];
}
